import { render, staticRenderFns } from "./StockBasketSales.vue?vue&type=template&id=b9f42380"
import script from "./StockBasketSales.vue?vue&type=script&lang=js"
export * from "./StockBasketSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports